import { parse, format } from 'date-fns';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import React, { useState, useEffect } from "react";
import Decimal from 'decimal.js';
import CryptoJS from 'crypto-js';

export function formatDatePT_MSSQL(inputDate) {
    // Parse the input date assuming it is in dd-MM-yyyy HH:mm:ss format
    const parsedDate = parse(inputDate, 'dd-MM-yyyy HH:mm:ss', Date());
    console.log("formatDatePT_MSSQL inputDate", inputDate);
    // Format the date to yyyy-MM-dd HH:mm:ss format
    return format(parsedDate, 'yyyy-MM-dd HH:mm:ss');
}

export const UppercaseInput = (event, setterFunction) => {
    const upperCaseValue = event.target.value.toUpperCase();
    setterFunction(upperCaseValue);
};

/**
 * Rounds and formats a number using banker's rounding and fixes it to a specified number of decimal places.
 * 
 * @param {number|string|Decimal} value The value to round and format.
 * @param {number} decimalPlaces The number of decimal places to round to and display.
 * @returns {string} The rounded and formatted number as a string.
 */

export function roundAndFormat(value, decimalPlaces) {
    //console.log(`roundAndFormat called with value=${value}, type=${typeof value}`);

    if (value === null || value === undefined) {
        return new Decimal(0).toFixed(decimalPlaces);
    }

    const stringValue = String(value);
    try {
        const decimalValue = new Decimal(stringValue);
        const roundedValue = decimalValue.toDecimalPlaces(decimalPlaces, Decimal.ROUND_HALF_EVEN);
        return roundedValue.toFixed(decimalPlaces);
    } catch (error) {
        console.error('Error in rounding/formatting:', error);
        throw error;
    }
}


export function converttoDecimalPonto(numStr) {
    // This checks if the input is a string and contains a comma
    if (typeof numStr === 'string' && numStr.includes(',')) {
        // Replace comma with dot for decimal separation
        return new Decimal(numStr.replace(',', '.'));
    }
    if (numStr === '') {
        numStr = '0';
    }

    return new Decimal(numStr); // Return the original string if no comma is found
};

export function converttoDecimalVirgula(numStr) {
    // This checks if the input is a string and contains a comma
    let numStr1 = numStr + '';
    if (numStr1.includes('.')) {
        // Replace comma with dot for decimal separation
        return numStr1.replace('.', ',');
    }
    return numStr1; // Return the original string if no comma is found
};



export function AlertMessage({ message, severity, open1 }) {
    const [open, setOpen] = React.useState(false);

    // Effect to handle open prop changes
    React.useEffect(() => {
        if (open1) {
            setOpen(true);
            const timer = setTimeout(() => {
                setOpen(false); // Automatically close after 3000ms
            }, 3000);
            return () => clearTimeout(timer); // Clean up the timer
        } else {
            setOpen(false); // Ensure it is closed if open1 is false
        }
    }, [open1]); // Dependency on open1

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);  // Close the snackbar
    };

    console.log("severity:", severity);

    const message1 =
        "This is a message \n This message has Enter in it \n MUI Alert does not honor the Enter \n I can not use dangerouslySetInnerHTML \n Because this message contains <h1>Hi</h1> in it \n And I want to show that HTML string to my user \n I don't want to render that HTML";


    return (
        <div>

            <Snackbar
                open={open}// Controlled by internal state
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert
                    onClose={handleClose}
                    severity={severity}
                    variant="filled"
                    sx={{ width: '100%', whiteSpace: 'pre-line' }}
                >
                    {message}
                </Alert>
            </Snackbar>
        </div >
    );
}


// Utility function to format the number. Fill with leading zeros
// formatNumberWithLeadingZeros(123, 6) => 000123
export function formatNumberWithLeadingZeros(number, length) {
    return number.toString().padStart(length, '0');
}



export const encodeId = (id) => {

    const SALT = 'SERVICEFLOW';

    const saltedId = `${id}${SALT}`;
    //return Buffer.from(saltedId).toString('base64');
    return btoa(saltedId);
};


export const encryptId = (id) => {

    const SECRET_KEY = 'SERVICEFLOW'; // Keep this secret and do not expose it

    const ciphertext = CryptoJS.AES.encrypt(id.toString(), SECRET_KEY).toString();
    return CryptoJS.enc.Hex.stringify(CryptoJS.enc.Base64.parse(ciphertext));
};




export default formatDatePT_MSSQL


